import React from 'react';
import { useParams } from 'react-router-dom';
import DetailsPage from '../components/DetailsPage';

function LicenceReportDetails() {
  const { reportName } = useParams();

  // Sample data - replace with actual data from your backend
  const reportData = [
    {
      licenceNo: 'TL001',
      customerName: 'John Doe',
      wordNo: 'Ward 1',
      phoneNumber: '1234567890',
      date: '2024-03-15',
      businessName: 'ABC Enterprises',
      amount: '₹5000'
    },
    {
      licenceNo: 'TL002',
      customerName: 'Jane Smith',
      wordNo: 'Ward 2',
      phoneNumber: '9876543210',
      date: '2024-03-16',
      businessName: 'XYZ Corporation',
      amount: '₹7500'
    },
    {
      licenceNo: 'TL003',
      customerName: 'Robert Johnson',
      wordNo: 'Ward 3',
      phoneNumber: '8765432109',
      date: '2024-03-17',
      businessName: '123 Industries',
      amount: '₹6000'
    }
  ];

  const columns = [
    { field: 'licenceNo', header: 'Licence No' },
    { field: 'customerName', header: 'Customer Name' },
    { field: 'wordNo', header: 'Word No' },
    { field: 'phoneNumber', header: 'Phone Number' },
    { field: 'date', header: 'Date' },
    { field: 'businessName', header: 'Business Name' },
    { field: 'amount', header: 'Amount' }
  ];

  const handleRowClick = (row) => {
    console.log('Row clicked:', row);
  };

  return (
    <DetailsPage
      title={reportName.replace(/-/g, ' ')}
      backPath="/licence"
      columns={columns}
      data={reportData}
      onRowClick={handleRowClick}
    />
  );
}

export default LicenceReportDetails; 